import { render, staticRenderFns } from "./subjectAllDetails.vue?vue&type=template&id=95a11150&scoped=true"
import script from "./subjectAllDetails.vue?vue&type=script&lang=js"
export * from "./subjectAllDetails.vue?vue&type=script&lang=js"
import style0 from "./subjectAllDetails.vue?vue&type=style&index=0&id=95a11150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a11150",
  null
  
)

export default component.exports